import React, { useState, useEffect, useContext } from 'react';
import axios from '../Common/axios.js';
import { Button, Input, Modal, Select, Table, DatePicker, Typography, Spin } from "antd";
import CodeSelect from '../Common/CodeSelect.js';
import { getGridTableHeight, getPopupSizeOption, dateFormatter } from '../Common/util.js';
import { getFindAnalysisList, postReportAll, postReportHistory, getTotalReportList } from '../Common/api.js';
import { excelDownload } from '../Common/function.js';
// import AnalysisCreate from './AnalysisCreate.js';
// import AnalysisInfo from '../AnalysisInfo/AnalysisInfo.js';
// import AnalysisResult from './AnalysisResult.js';
import AppContext from '../../components/AppContext.js';
import Cookies from 'js-cookie';
import TopMenu from '../Common/TopMenu.js';
import { getCodeName } from '../Common/CodeSelect.js';
import DownloadUrl from '../../components/DownloadUrl';
import { DownloadMd } from '../../components/DownloadPdf';
import Column from 'antd/es/table/Column.js';
import { getCodeList } from '../Common/codeManager';
import MarkdownViewer from '../../components/MarkdownViewer';
import { getPdfDownload } from '../Common/api.js';

const { Option } = Select;
const { RangePicker } = DatePicker;

/** -------------------------------------------------------------------------- **/
const AnalysisListBox = () => {
    const myContext = useContext(AppContext);
    //console.log(myContext);

    // 쿠키에서 인증 토큰 값 가져오기
    const authToken = Cookies.get('access_token');
    // 인증 토큰 값이 존재하면 로그인된 상태로 처리
    const authenticated = authToken ? true : false;

    // 변수 선언
    const [companyCode, setCompanyCode] = useState(myContext.companyCode);
    const [companyName, setCompanyName] = useState(myContext.companyName);
    const [assetType, setAssetType] = useState(myContext.assetType);
    const [assetTypeName, setAssetTypeName] = useState(myContext.assetTypeName);
    const [reportName, setReportName] = useState('');
    const [startYmd, setStartYmd] = useState('');
    const [endYmd, setEndYmd] = useState('');

    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [isDataChange, setIsDataChange] = useState(false);
    const [isOpenInfo, setIsOpenInfo] = useState(false);

    const [isReportId, setIsReportId] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [spinflag, setSpinflag] = useState(false);
    const loadDefaultMessage = "Loading...";
    const [loadMessage, setLoadMessage] = useState(loadDefaultMessage);
    const [totalReportType, setTotalReportType] = useState("total_analy")
    const [columnName, setColumnName] = useState([]);
    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys) => {
            setSelectedRowKeys(newSelectedRowKeys);
        },
    };
    const [isReportLoading, setIsReportLoading] = useState(true);
    const uiHistoryReport = ["생성일자", "보고서명"];
    const uiAnalyReport = ["최초분석일자", "취약점 분석명"];
    const [uiObjName, setUiObjName] = useState(uiAnalyReport);
    const [markdownVisible, setMarkdownVisible] = useState(false);
    const [markdownContent, setMarkdownContent] = useState('');
    const [markdownReportId, setMarkdownReportId] = useState('');

    // 페이지 진입 시 코드 목록 갱신
    useEffect(() => {
        // 캐시된 코드 목록 갱신 (1분 캐시)
        getCodeList();
    }, []);

    // 회사코드 또는 보고서 유형 변경 시 자동 조회
    useEffect(() => {
        // 회사코드가 있을 때만 조회
        if (companyCode) {
            if (totalReportType == "total_analy_history") {
                findTotalReportList();
                setIsReportLoading(false);
            } else {
                findAnalysisList();
                setIsReportLoading(true);
            }
        }
    }, [companyCode, totalReportType]);

    // 배열을 localStorage에 저장
    const storageSaveArray = (key, arr) => {
        localStorage.setItem(key, JSON.stringify(arr));
    }

    const storageLoadArray = (key) => {
        const data = localStorage.getItem(key);
        return data ? JSON.parse(data) : [];
    }

    // 배열에 아이템 추가
    const storageAddToArray = (key, item) => {
        const arr = storageLoadArray(key) ? storageLoadArray(key) : [];
        if (!arr.includes(item)) {
            if (arr.length >= 3) arr.shift();
            arr.push(item);
            storageSaveArray(key, arr);
        }
    }

    // 배열에서 아이템 제거
    // const storageRemoveFromArray = (key, item) => {
    //     const arr = storageLoadArray(key).filter(v => v !== item);
    //     storageSaveArray(key, arr);
    // }

    /** -------------------------------------------------------------------------- **/
    // 회사코드 변경
    const onChangeCompanyCode = (value, option) => {
        setCompanyCode(value);
        setCompanyName(option.children[2]);
        myContext.setCompanyCode(value);
        myContext.setCompanyName(option.children[2]);
    };

    // 통합리포트 유형 변경
    const onChangeTotalReportType = (value, option) => {
        setTotalReportType(value);
        // initDataChange();

        if (value == "total_analy_history") {
            setUiObjName(uiHistoryReport);
        } else {
            setUiObjName(uiAnalyReport);
        }
    };

    // 자산유형 변경
    const onChangeAssetType = (value, option) => {
        setAssetType(value);
        setAssetTypeName(option.children[2]);
        myContext.setAssetType(value);
        myContext.setAssetTypeName(option.children[2]);
    };

    // 최초분석일자 변경
    const onChangeDateRange = (values, formatString) => {
        //console.log(formatString);
        if (formatString != null) {
            if (formatString.length >= 1) {
                setStartYmd(formatString[0].replace(/[-]/g, ''));
            }
            if (formatString.length >= 2) {
                setEndYmd(formatString[1].replace(/[-]/g, ''));
            }
        }
    };

    // 검색 데이터 초기화(날짜 검색이 초기화 안되고 있음)
    const initDataChange = () => {
        setStartYmd('');
        setEndYmd('');
        setReportName('');
    }
    // 검색 클릭 시
    const onClickSearchHandler = (paramReportType) => {
        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({ title: "회사는 필수 조회조건입니다." });
            return;
        }

        const currentReportType = (typeof paramReportType === 'string') ? paramReportType : totalReportType;
        // 보고서 조회
        if (currentReportType == "total_analy_history") {
            findTotalReportList();
            setIsReportLoading(false);
        } else {
            findAnalysisList();
            setIsReportLoading(true);
        }

    };

    // 취약점 분석 조회 API
    const findAnalysisList = () => {
        setIsLoading(true);
        setIsDataChange(false);

        axios.get(getFindAnalysisList(companyCode, "", reportName, startYmd, endYmd))
            .then((response) => {

                setColumnName(analysisColumnData);
                setIsLoading(false);
                if (response.data.totalCount == 0) {
                    Modal.info({ title: "No Data.", okText: "Close" });
                }

                const newData = response.data.filter(item => item.created_ymd != null && item.created_ymd != '');
                setDataSource(newData);
            })
            .catch((error) => {
                console.log("AnalysisListBox --- 132 error");
                console.dir(error);
                setIsLoading(false);
            });
    };

    // 통합 리포트 조회 API
    const findTotalReportList = () => {
        setIsLoading(true);
        setIsDataChange(false);

        axios.get(getTotalReportList(companyCode, reportName, startYmd, endYmd))
            .then((response) => {

                setIsLoading(false);

                setColumnName(totalAnalysisColumnData);
                if (response.data.totalCount == 0) {
                    Modal.info({ title: "No Data.", okText: "Close" });
                }

                const newData = response.data.filter(item => item.created_ymd != null && item.created_ymd != '');
                setDataSource(newData);
            })
            .catch((error) => {
                console.log("AnalysisListBox --- 159 error");
                console.dir(error);
                setIsLoading(false);
            });
    };

    const fromUnicodeEscape = (str) => {
        return str.replace(/\\u[\dA-Fa-f]{4}/g, match => {
            return String.fromCharCode(parseInt(match.replace('\\u', ''), 16));
        });
    }

    // 통합 보고서ID 클릭 시 Markdown 보기
    const onClickConsolidatedReport = (reportId) => {
        setSpinflag(true);
        setLoadMessage("통합 보고서 Markdown을 불러오는 중입니다...");
        setMarkdownReportId(reportId);

        axios.get(getPdfDownload("consolidated_md", reportId))
            .then((response) => {
                setMarkdownContent(response.data);
                setMarkdownVisible(true);
                setSpinflag(false);
                setLoadMessage(loadDefaultMessage);
            })
            .catch((error) => {
                Modal.error({
                    title: "통합 보고서 조회 실패",
                    content: "Markdown 데이터를 불러오는 중에 오류가 발생했습니다.",
                    okText: "닫기"
                });
                setSpinflag(false);
                setLoadMessage(loadDefaultMessage);
            });
    };

    // 통합보고서 생성 (outputFormat: 'pdf' 기본 | 'docx' Word / reportMode: 'report' 기본 | 'plan' 진단 계획서)
    const pdfDownLoadReport = (event, outputFormat = 'pdf', reportMode = 'report') => {

        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({ title: "회사는 필수 조회조건입니다." });
            return;
        }

        // 진단 계획서는 대상(리포트) 미선택이어도 자산목록 기반으로 생성 가능
        if (reportMode !== 'plan' && selectedRowKeys.length < 1) {
            Modal.info({ title: "보고서 생성할 대상을 선택하세요." });
            return;
        }

        const hasInvalid = members.some(member => getMessageColor(member) === 'red');

        if (hasInvalid) {
            Modal.info({ title: "보고서 입력 정보를 확인하세요. ('참고내용' 확인)" });
            return; // 이후 처리 중단
        }

        members.forEach(member => {
            storageAddToArray("report_user_name", member.name);
            storageAddToArray("report_user_email", member.email);
            storageAddToArray("report_user_part", member.part);
        });
        // localStorage.setItem("report_user_name", JSON.stringify(storageLoadArray("report_user_name")));
        // localStorage.setItem("report_user_email", JSON.stringify(storageLoadArray("report_user_email")));
        // localStorage.setItem("report_user_part", JSON.stringify(storageLoadArray("report_user_part")));

        // localStorage.setItem("report_user_name", members[0].name);
        // localStorage.setItem("report_user_email", members[0].email);
        // localStorage.setItem("report_user_part", members[0].part);

        setSpinflag(true);
        setLoadMessage("잠시만 기다려 주세요. 보고서 작성중 입니다.");

        const reportIds = selectedRowKeys.join(',');
        const titleName = "통합 보고서 생성";
        const buttonType = event.currentTarget.textContent;
        const membersReport = members.map(({ id, ...rest }) => rest);

        // reportType 설정 - 보고서 구분에 따라 다르게 설정
        let reportType = "consolidated"; // 기본값
        if (totalReportType === "total_analy") {
            reportType = "consolidated";
        } else if (totalReportType === "total_analy_risk") {
            reportType = "consolidated_riskeval";
        } else if (totalReportType === "total_analy_manage") {
            reportType = "consolidated_riskmgmt";
        }

        if (buttonType === 'Markdown') {
            axios.get(getPdfDownload("asset_md", reportId)).then((response) => {
                DownloadMd(response.data, reportId, reportName);
                setSpinflag(false);
            }).catch((error) => {
                Modal.error({ title: titleName, content: "Markdown파일 다운로드 중에 에러가 발생하였습니다.", okText: "Close" });
                setSpinflag(false);
            });
        } else {
            axios.post(postReportAll(), {
                reportIds: reportIds,
                reportType: reportType,
                consultant: membersReport,
                format: outputFormat,       // 'pdf'(기존) | 'docx'(Word)
                mode: reportMode,           // 'report'(기존) | 'plan'(진단 계획서)
                companyCode: companyCode    // 계획서 단독 생성 시 대상 회사 자산목록 조회용
            }).then((response) => {
                let responseData = null;

                if (typeof response.data === 'string') {
                    const resStrData = fromUnicodeEscape(response.data).replace(/:\s*NaN/g, ': null');
                    console.log("Response Data:", resStrData);
                    responseData = JSON.parse(resStrData);
                } else {
                    responseData = response.data;
                }
                // ConsolidatedReport 처리
                // const consolidatedMatch = responseData.match(/"ConsolidatedReport":\s*(\{[^}]+\{[^}]+\}[^}]*\})/);
                // const consolidatedStr = consolidatedMatch[1];
                // const consolidatedReport = JSON.parse(consolidatedStr);    
                // const resStatusUrl = consolidatedReport.data.status_url;

                const resStatusUrl = responseData?.ConsolidatedReport?.data?.status_url;

                if (resStatusUrl) {
                    DownloadUrl(resStatusUrl,
                        () => {
                            setSpinflag(false); // onSuccess
                            setLoadMessage(loadDefaultMessage);
                        },
                        (errorMessage) => {
                            Modal.info({ title: titleName, content: errorMessage, okText: "Close" });
                            setSpinflag(false);
                            setLoadMessage(loadDefaultMessage);
                        }
                    );
                } else {
                    const errorAddMessage = responseData?.ConsolidatedReport?.error ? responseData.ConsolidatedReport.error : "데이터 값이 없습니다.";
                    Modal.info({ title: titleName, content: (<div>다운로드 중에 에러가 발생하였습니다.<br />({errorAddMessage})</div>), okText: "Close" });
                    setSpinflag(false);
                    setLoadMessage(loadDefaultMessage);
                }
            }).catch((error) => {
                Modal.error({ title: titleName, content: error.message, okText: "Close" });
                setSpinflag(false);
                setLoadMessage(loadDefaultMessage);
            });
        }
    }


    // 비교 진단 보고서 생성
    const pdfDownLoadHistoryReport = (event) => {

        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({ title: "회사는 필수 조회조건입니다." });
            return;
        }

        if (selectedRowKeys.length != 2) {
            Modal.info({ title: "비교 분석 보고서는 2개를 선택해야 합니다." });
            return;
        }

        const hasInvalid = members.some(member => getMessageColor(member) === 'red');

        if (hasInvalid) {
            Modal.info({ title: "보고서 입력 정보를 확인하세요. ('참고내용' 확인)" });
            return; // 이후 처리 중단
        }


        setSpinflag(true);
        setLoadMessage("잠시만 기다려 주세요. 보고서 작성중 입니다.");

        const reportIds = selectedRowKeys.join(',');
        const titleName = "비교 분석 보고서 생성";
        const buttonType = event.currentTarget.textContent;
        const membersReport = members.map(({ id, ...rest }) => rest);

        if (buttonType === 'Markdown') {
            axios.get(getPdfDownload("asset_md", reportId)).then((response) => {
                DownloadMd(response.data, reportId, reportName);
                setSpinflag(false);
            }).catch((error) => {
                Modal.error({ title: titleName, content: "Markdown파일 다운로드 중에 에러가 발생하였습니다.", okText: "Close" });
                setSpinflag(false);
            });
        } else {
            axios.post(postReportHistory(), {
                reportIds: reportIds,
                // reportType: "consolidated",
                // consultant: membersReport
            }).then((response) => {
                let data = response.data;

                // 혹시 문자열로 온 경우 파싱
                if (typeof data === 'string') {
                    try {
                        data = JSON.parse(data);
                    } catch (error) {
                        console.error("JSON 파싱 실패:", error);
                        Modal.error({ title: titleName, content: "서버 응답 처리 중 오류가 발생했습니다.", okText: "Close" });
                        setSpinflag(false);
                        setLoadMessage(loadDefaultMessage);
                        return;
                    }
                }

                // ConsolidatedReport 처리
                // if (data?.ConsolidatedReport?.data) {
                //     const resStatusUrl = data.ConsolidatedReport.data.status_url;
                //     const taskId = data.ConsolidatedReport.data.task_id;

                // ConsolidatedReport 처리
                if (data.data[0]?.task_id) {
                    const resStatusUrl = data.data[0].status_url;
                    const taskId = data.data[0].task_id;

                    console.log("Task ID:", taskId); // Add this line
                    if (resStatusUrl) {
                        DownloadUrl(resStatusUrl,
                            () => {
                                setSpinflag(false);
                                setLoadMessage(loadDefaultMessage);
                            },
                            (errorMessage) => {
                                Modal.info({ title: titleName, content: errorMessage, okText: "Close" });
                                setSpinflag(false);
                                setLoadMessage(loadDefaultMessage);
                            }
                        );
                    } else {
                        Modal.info({ title: titleName, content: "다운로드 중에 에러가 발생하였습니다.", okText: "Close" });
                        setSpinflag(false);
                        setLoadMessage(loadDefaultMessage);
                    }
                } else {
                    Modal.error({ title: titleName, content: "통합 보고서 생성에 실패했습니다.", okText: "Close" });
                    setSpinflag(false);
                    setLoadMessage(loadDefaultMessage);
                }
            }).catch((error) => {
                Modal.error({ title: titleName, content: error.message, okText: "Close" });
                setSpinflag(false);
                setLoadMessage(loadDefaultMessage);
            });
        }
    }

    // 화면로딩시 자동조회
    useEffect(() => {
        window.onHandleDataChange = () => {
            setIsDataChange(true);
        };

        if (companyCode != '') {
            findAnalysisList();
        }
    }, []);

    // 정보 변경시 재조회
    useEffect(() => {
        // 취약점분석 조회
        if (isDataChange && companyCode != '') {
            if (totalReportType == "total_analy_history") {
                findTotalReportList();
            } else {
                findAnalysisList();
            }
        }
    }, [isDataChange]);

    /** -------------------------------------------------------------------------- **/
    function onClickDetailHandler(value) {

        var _width = '1400';
        var _height = '900';
        const option = getPopupSizeOption(_width, _height);

        if (value.columnType == 'info') {
            const url = '#/analysis/info/' + value.report_id;
            const target = 'analysisInfo';
            //window.open(url, target, option);
            setIsOpenInfo(true);
            setIsReportId(value.report_id);

        } else if (value.columnType == 'created_result' || value.columnType == 'updated_result') {

            const resultType = value.columnType == 'created_result' ? 'C' : 'U';
            const url = '#/analysis/resultpop/' + value.report_id + '/' + resultType;
            const target = 'analysisResult';
            const option_fix = getPopupSizeOption('1600', '1100', 'fix');
            window.open(url, target, option_fix);

        } else if (value.columnType == 'vulnerablity' || value.columnType == 'riskReport' || value.columnType == 'riskManagement' || value.columnType == 'implement') {
            const url = '#/report/' + value.columnType + '/' + value.report_id + (value.companyCode ? '?cd=' + value.companyCode : '');
            const target = value.columnType;
            window.open(url, target, option);

        } else if (value.columnType == 'assetReport') {
            // const url = '#/report/'+value.columnType+'/'+value.report_id+'/'+value.asset_cd+'/'+value.com_cd+'/'+value.asset_type;
            // 상세진단결과 팝업창에 파라미터로 전달되는 경로패스 수정 
            // App.js 에서 {AssetReport}값이 있는 라우터 경로도 수정해줘야 한다. 
            const url = '#/report/' + value.columnType + '/' + value.report_id;
            const target = value.columnType;
            const option_fix = getPopupSizeOption('1500', '900', 'fix');
            window.open(url, target, option_fix);

        } else if (value.columnType == 'implementResult') {
            const url = '#/report/' + value.columnType + '/' + value.report_id;
            const target = value.columnType;
            const option_fix = getPopupSizeOption('1500', '900', 'fix');
            window.open(url, target, option_fix);

        }

    };

    // 취약점분석_목록
    const analysisColumnData = [
        {
            title: '자산구분',
            dataIndex: 'asset_type',
            key: 'asset_type',
            width: '100px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.asset_type.localeCompare(b.asset_type),
            },
            render: (_, rowData) => {
                return (
                    getCodeName('asset_type', rowData.asset_type)
                );
            },
        },
        {
            title: '취약점분석ID',
            dataIndex: 'report_id',
            key: 'report_id',
            width: '120px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.report_id.localeCompare(b.report_id),
            },
        },
        {
            title: '취약점분석명',
            dataIndex: 'report_nm',
            key: 'report_nm',
            width: '250px',
            align: 'center',
            fixed: true,
            ellipsis: true,
            render: (_, rowData) => {
                return (
                    <div style={{ color: '#0030A5' }}>
                        {rowData.report_nm}
                    </div>
                );
            },
            sorter: {
                compare: (a, b) => a.report_nm.localeCompare(b.report_nm),
            },
        },
        {
            title: '확정여부',
            dataIndex: 'confirm',
            key: 'confirm',
            width: '50px',
            align: 'center',
            fixed: true,
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.confirm.localeCompare(b.confirm),
            },
        },
        {
            title: '최초분석일',
            dataIndex: 'created_ymd',
            key: 'created_ymd',
            width: '70px',
            align: 'center',
            render: (_, rowData) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({ columnType: 'created_result', report_id: rowData.report_id })}>
                        {rowData.created_ymd && rowData.created_ymd != 'None' ? dateFormatter(rowData.created_ymd) : 'Upload'}
                    </Typography.Link>
                );
            },
            // className: 'sum_col'
        },
        // {
        //     title: '취약점진단',
        //     dataIndex: 'vulnerablity',
        //     key: 'vulnerablity',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'vulnerablity', report_id: rowData.report_id})}>
        //                 {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        // {
        //     title: '상세진단결과',
        //     dataIndex: 'assetReport',
        //     key: 'assetReport',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'assetReport', report_id: rowData.report_id})}>
        //                 {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        // {
        //     title: '위험평가',
        //     dataIndex: 'riskReport',
        //     key: 'riskReport',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'riskReport', report_id: rowData.report_id, companyCode: companyCode})}>
        //                 {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        // {
        //     title: '위험관리',
        //     dataIndex: 'riskManagement',
        //     key: 'riskManagement',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'riskManagement', report_id: rowData.report_id})}>
        //                 {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        {
            title: '이행점검일',
            dataIndex: 'updated_ymd',
            key: 'updated_ymd',
            width: '70px',
            align: 'center',
            render: (_, rowData) => {
                return (
                    rowData.updated_ymd != "" && rowData.updated_ymd != null ? (
                        <Typography.Link onClick={() => onClickDetailHandler({ columnType: 'updated_result', report_id: rowData.report_id })}>
                            {rowData.updated_ymd && rowData.updated_ymd != 'None' ? dateFormatter(rowData.updated_ymd) : 'Upload'}
                            {/* rowData.created_ymd && rowData.created_ymd!='None'?'Upload':'없음'} */}
                        </Typography.Link>) : "X"
                );
            },
            // className: 'sum_col'
        },
        // {
        //     title: '이행진단',
        //     dataIndex: 'implement',
        //     key: 'implement',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'implement', report_id: rowData.report_id})}>
        //                 { rowData.updated_ymd && rowData.updated_ymd!='None' && (rowData.created_ymd <= rowData.updated_ymd) ?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        // {
        //     title: '이행결과',
        //     dataIndex: 'implementResult',
        //     key: 'implementResult',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'implementResult', report_id: rowData.report_id})}>
        //                 { rowData.updated_ymd && rowData.updated_ymd!='None' && (rowData.created_ymd <= rowData.updated_ymd) ?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
    ];


    // 취약점분석_목록
    const totalAnalysisColumnData = [
        {
            title: '통합 보고서ID',
            dataIndex: 'report_id',
            key: 'report_id',
            width: '120px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.report_id.localeCompare(b.report_id),
            },
            render: (_, rowData) => {
                return (
                    <Typography.Link onClick={() => onClickConsolidatedReport(rowData.report_id)}>
                        {rowData.report_id}
                    </Typography.Link>
                );
            },
        },
        {
            title: '취약점 보고서명',
            dataIndex: 'original_report_names',
            key: 'original_report_names',
            width: '120px',
            align: 'center',
            fixed: true,
            render: (_, rowData) => {
                let originalReport = "";

                if (rowData.original_report_names == null || rowData.original_report_names.length < 1) {
                    originalReport = "없음";
                } else {
                    originalReport = rowData.original_report_names.map((item, index) => {
                        return (
                            <div key={index} style={{ color: '#0030A5' }}>
                                {item}
                            </div>
                        );
                    });
                }

                return (
                    <div style={{ textAlign: 'left', marginLeft: '10px', display: 'inline-block' }}>
                        {originalReport}
                    </div>
                );
            },
        },
        {
            title: '자산갯수',
            dataIndex: 'total_asset_count',
            key: 'total_asset_count',
            width: '50px',
            align: 'center',
            fixed: true,
            ellipsis: true,
            render: (_, rowData) => {
                return (
                    <div style={{ color: '#0030A5' }}>
                        {rowData.total_asset_count}
                    </div>
                );
            },
            sorter: {
                compare: (a, b) => Number(b.total_measure_count) - Number(a.total_measure_count),
            },
        },
        {
            title: '항목갯수',
            dataIndex: 'total_measure_count',
            key: 'total_measure_count',
            width: '50px',
            align: 'center',
            render: (_, rowData) => {
                return (
                    <div style={{ color: '#0030A5' }}>
                        {rowData.total_measure_count}
                    </div>
                );
            },
            sorter: {
                compare: (a, b) => Number(b.total_measure_count) - Number(a.total_measure_count),
            },
            // className: 'sum_col'
        },
        {
            title: '보고서 생성일',
            dataIndex: 'created_at',
            key: 'created_at',
            width: '70px',
            align: 'center',
            render: (_, rowData) => {
                const new_created_at = new Date(rowData.created_at);
                return (
                    <div style={{ color: '#0030A5' }}>
                        {new_created_at.toLocaleString()}
                    </div>
                );
            },
            // className: 'sum_col'
        },
    ];

    // 담당자 정보를 배열로 관리
    const [members, setMembers] = useState([
        {
            id: 1,
            name: storageLoadArray("report_user_name")[0] ? storageLoadArray("report_user_name")[0] : '관리자',
            email: storageLoadArray("report_user_email")[0] ? storageLoadArray("report_user_email")[0] : 'manager@example.com',
            part: storageLoadArray("report_user_part")[0] ? storageLoadArray("report_user_part")[0] : '보안팀'
        }
    ]);

    // 입력 필드 변경 핸들러
    // const onChangeInputHandler = (e, id, field) => {
    //     const value  = e.target;
    //     setMembers(prevMembers => 
    //         prevMembers.map(member => 
    //             member.id === id ? { ...member, [field]: value } : member
    //         )
    //     );
    // };

    // InputText 입력값 변경
    const onChangeInputHandler = (e, id, field) => {

        if (e.target.id == "reportName" && id == 'reportName') {
            setReportName(e.target.value);
        } else {
            const value = e.target.value;
            setMembers(prevMembers =>
                prevMembers.map(member =>
                    member.id === id ? { ...member, [field]: value } : member
                )
            );
        }
    };

    // 인원 추가 
    const onAddMember = () => {
        const newId = members.length > 0 ? Math.max(...members.map(m => m.id)) + 1 : 1;
        const newIndex = newId - 1;
        setMembers([...members, {
            id: newId,
            name: storageLoadArray("report_user_name")[newIndex] ? storageLoadArray("report_user_name")[newIndex] : '',
            email: storageLoadArray("report_user_email")[newIndex] ? storageLoadArray("report_user_email")[newIndex] : '',
            part: storageLoadArray("report_user_part")[newIndex] ? storageLoadArray("report_user_part")[newIndex] : ''
        }]);
    };

    // 인원 삭제
    const onRemoveMember = (id) => {
        setMembers(prevMembers => prevMembers.filter(member => member.id !== id));
    };

    const getErrorMessage = (member) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (member.name.length < 1) return '담당자 이름을 입력하세요.';
        if (member.email.length < 1) return '이메일을 입력하세요.';
        if (!emailRegex.test(member.email)) return '올바른 이메일 형식이 아닙니다.';
        if (member.part.length < 2) return '담당업무를 입력하세요.(2자 이상)';
        return '정상적으로 입력되었습니다.';
    };

    const getMessageColor = (member) => {
        return getErrorMessage(member) === '정상적으로 입력되었습니다.' ? 'blue' : 'red';
    };

    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <Spin size={"large"} style={{ top: "200px", left: "2%" }} tip={loadMessage} spinning={spinflag}>
                <TopMenu selectKey='totalReport' />
                <div className="section">
                    <table className='search'>
                        <colgroup>
                            <col style={{ width: '5%' }} />
                            <col style={{ width: '18%' }} />
                            <col style={{ width: '6%' }} />
                            <col style={{ width: '18%' }} />
                            <col style={{ width: '7%' }} />
                            <col style={{ width: '18%' }} />
                            <col style={{ width: '7%' }} />
                            <col style={{ width: '15%' }} />
                            <col style={{ width: '6%' }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th><span className='req'>*</span>회사</th>
                                <td>
                                    <CodeSelect codeType="com_cd"
                                        id="companyCode"
                                        value={companyCode}
                                        disabled={authenticated ? true : false}
                                        onChangeHandler={onChangeCompanyCode}
                                    />
                                </td>
                                <th>보고서구분</th>
                                <td>
                                    <Select id="totalReportType"
                                        size="small"
                                        style={{ width: "80%" }}
                                        value={totalReportType}
                                        onChange={onChangeTotalReportType}
                                    >
                                        <Option key="1" value="total_analy">통합 진단 보고서</Option>
                                        <Option key="2" value="total_analy_risk">통합 위험분석 보고서</Option>
                                        <Option key="3" value="total_analy_manage">통합 위험관리 보고서</Option>
                                        <Option key="4" value="total_analy_history">비교 분석 보고서</Option>
                                    </Select>
                                </td>
                                <th>{uiObjName[0]}</th>
                                <td>
                                    <RangePicker id="createYmd" size="small"
                                        onChange={onChangeDateRange}
                                    />
                                </td>
                                <th>{uiObjName[1]}</th>
                                <td>
                                    <Input id="reportName" size="small"
                                        allowClear
                                        value={reportName}
                                        onChange={(e) => onChangeInputHandler(e, 'reportName', '')}
                                        onPressEnter={() => onClickSearchHandler()}
                                    />
                                </td>
                                <th><Button type="default" onClick={onClickSearchHandler}>조회</Button></th>
                            </tr>
                        </tbody>
                    </table>
                    <table className='search'>
                        <colgroup>
                            <col style={{ width: '5%' }} />
                            <col style={{ width: '18%' }} />
                            <col style={{ width: '6%' }} />
                            <col style={{ width: '18%' }} />
                            <col style={{ width: '7%' }} />
                            <col style={{ width: '18%' }} />
                            <col style={{ width: '7%' }} />
                            <col style={{ width: '15%' }} />
                            <col style={{ width: '6%' }} />
                        </colgroup>
                        <tbody>
                            {members.map((member, index) => (
                                <tr key={member.id}>
                                    <th>{<span className='req'>*</span>}담당자</th>
                                    <td>
                                        <Input
                                            size="small"
                                            allowClear
                                            value={member.name}
                                            onChange={(e) => onChangeInputHandler(e, member.id, 'name')}
                                        />
                                    </td>
                                    <th>{<span className='req'>*</span>}이메일</th>
                                    <td>
                                        <Input
                                            size="small"
                                            allowClear
                                            value={member.email}
                                            onChange={(e) => onChangeInputHandler(e, member.id, 'email')}
                                        />
                                    </td>
                                    <th>{<span className='req'>*</span>}담당업무</th>
                                    <td>
                                        <Input
                                            size="small"
                                            allowClear
                                            value={member.part}
                                            onChange={(e) => onChangeInputHandler(e, member.id, 'part')}
                                        />
                                    </td>
                                    <th>참고내용</th>
                                    <td>
                                        <span id={`errNo${member.id}`} style={{ color: getMessageColor(member) }}>
                                            {getErrorMessage(member)}
                                        </span>
                                    </td>
                                    <th>
                                        {/* {index === members.length - 1 ? ( */}
                                        {index === 0 ? (
                                            <Button type="default" onClick={onAddMember}>인원 추가</Button>
                                        ) : (
                                            <Button danger onClick={() => onRemoveMember(member.id)}>삭제</Button>
                                        )}
                                    </th>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="search_button">
                        {isReportLoading ? (
                            <>
                                <Button type="primary" onClick={pdfDownLoadReport}>PDF 보고서 생성</Button>
                                {(totalReportType === 'total_analy' || totalReportType === 'total_analy_risk') && (
                                    <Button type="primary" style={{ marginLeft: 8 }}
                                        onClick={(e) => pdfDownLoadReport(e, 'docx')}>Word 보고서 생성</Button>
                                )}
                                {totalReportType === 'total_analy' && (
                                    <Button type="primary" style={{ marginLeft: 8 }}
                                        onClick={(e) => pdfDownLoadReport(e, 'docx', 'plan')}>진단 계획서 생성</Button>
                                )}
                            </>
                        ) : (
                            <Button type="primary" onClick={pdfDownLoadHistoryReport}>비교 분석 보고서 생성</Button>
                        )}
                        {/* <Button type="primary" onClick={pdfDownLoadReport}>통합 위험 분석 보고서</Button>
                    <Button type="primary" onClick={pdfDownLoadReport}>통합 위험 관리 보고서</Button> */}
                    </div>
                </div>
                <div className="section">
                    <table style={{ width: '100%' }}><tbody>
                        <tr>
                            <td width="120px"><div style={{ margin: '10px 10px 10px 20px' }}>총 {dataSource?.length} 개</div></td>
                            <td><div>*아래에서 통합 또는 비교 할  보고서를 선택해 주세요.</div></td>
                            <td style={{ textAlign: 'right' }}>
                                {/* <Button type="default" onClick={()=> excelDownload('취약점분석 목록', dataSource)}> Excel Download</Button> */}
                            </td>
                        </tr></tbody>
                    </table>
                    <Table columns={columnName}
                        dataSource={dataSource}
                        rowKey="report_id"
                        scroll={{ y: getGridTableHeight(340) }}
                        loading={{
                            size: "large",
                            spinning: isLoading
                        }}
                        pagination={false}
                        bordered size={"small"}
                        // style={{height:getGridTableHeight(260)}}
                        showSorterTooltip={false}
                        rowSelection={{
                            type: 'checkbox',
                            columnWidth: 22,
                            ...rowSelection,
                        }}
                    />
                </div>
                {/* {isOpenCreate && (<AnalysisCreate
                open={isOpenCreate}
                p_companyCode={companyCode}
                p_companyName={companyName}
                p_assetType={assetType}
                p_assetTypeName={assetTypeName}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenCreate(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
            {isOpenInfo && (<AnalysisInfo
                open={isOpenInfo}
                p_reportId={isReportId}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenInfo(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
            {isOpenResult && (<AnalysisResult
                open={isOpenResult}
                p_reportId={isReportId}
                p_resultType={isResultType}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenResult(false);
                    setIsDataChange(p_isChange);
                }}
            />)} */}
            </Spin>
            <MarkdownViewer
                visible={markdownVisible}
                onClose={() => setMarkdownVisible(false)}
                markdownContent={markdownContent}
                reportId={markdownReportId}
                reportName="비교 분석 보고서"
            />
        </>
    );
}
export default AnalysisListBox;
